<template>
    <div>
        <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="主订单号" prop="orderMainNo"></el-table-column>
            <el-table-column label="昵称" prop="nickName"></el-table-column>
            <el-table-column label="头像" prop="orderMainNo">
                <template slot-scope="scope">
                    <img :src="scope.row.headImageUrl" width="60" height="60" class="head_pic"/>
                </template>
            </el-table-column>
            <el-table-column prop="orderSourceName" label="订单来源"></el-table-column>
            <el-table-column prop="statusClassName" label="订单类型"></el-table-column>
            <el-table-column prop="statusName" label="订单状态"></el-table-column>
            <el-table-column prop="createTime" label="创单时间"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="handleDetail(scope.row.customerId)">客户详情</el-button>
                        <el-button type="primary" size="mini" @click="toOrderDetail(scope.row.orderMainNo)">订单详情</el-button>
                    </el-button-group>

                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="短信设置" :visible.sync="showDialog">
            <el-form :model="message" label-width="120px">
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="message.mobile" placeholder="mobile"></el-input>
                </el-form-item>
                <el-form-item label="模板选择" >
                    <el-input v-model="message.templateId" placeholder="templateId"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="sendSms()" class="header-btn">
                        发送短信
                    </el-button>
                    <el-button type="primary" @click="sendSms2()" class="header-btn">
                        发送短信
                    </el-button>
                </el-form-item>

            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        sendSmsApi,getMongateBalanceApi
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: true,
                message: {
                    mobile: 15168138426,
                    templateId: 1
                },
                loading: true,
                rules: {
                    endTime: [
                        {required: true, message: '结束时间必填', trigger: 'blur'}
                    ],
                    startingPrice: [
                        {required: true, message: '开始时间必填', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    startingPrice: [
                        {required: true, message: '请输入拼单起步价', trigger: 'blur'}
                    ],
                    discount: [
                        {required: true, message: '请输入新人优惠金额', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){

        },
        methods: {
            sendSms(row){
                this.$confirm('操作不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //删除继续
                    sendSmsApi({mobile: this.message.mobile,templateId:this.message.templateId}).then((res) => {
                        console.log(res);
                        if (res.data.success) {

                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
            sendSms2(row){
                //删除继续
                getMongateBalanceApi({mobile: this.message.mobile,templateId:this.message.templateId}).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.getActiveRuleList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/smsSend.vue